import { Breadcrumbs, Grid, Link, Typography } from '@mui/material';
import { Box } from '@mui/material';
import React from 'react';
import Accounts from './HomePage/Accounts';

export default function MyAccount() {
    const theme = localStorage.getItem('theme') || 'dark';
    return (
        <Box sx={{ display: 'flex', width: '100%', height: '100%' }}>
            <Grid container spacing={2} sx={{ width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <Accounts theme={theme} height={1000} fullFeatured={true} pageSize={50}/>
                </Grid>
            </Grid>
        </Box>
    )
}